import { createTheme } from '@mui/material';

let theme = createTheme({
	components: {
		MuiSnackbar: {
			styleOverrides: {
				root: {
					width: '1200px',
				},
			},
		},
		MuiButton: {
			variants: [
				{
					props: { variant: 'contrast' },
					style: {
						color: '#000',
						borderColor: '#000',
						':hover': {
							backgroundColor: 'rgba(87, 141, 64, 0.9)',
						},
					},
				},
			],
		},
	},
	typography: {
		// Non standard headings - to be brought in line for the design system
		'dashboard-card-heading': {
			fontSize: 24,
			fontWeight: 400,
			lineHeight: '32px',
			color: '#0D5EE3',
		},
	},
	palette: {
		primary: {
			light: '#F2AA8E',
			dark: '#B44F28',
			main: '#ED855D',
			pale: '#F2AA8E',
		},
		secondary: {
			light: '#A8C5F5',
			main: '#0D5EE3',
			dark: '#19269E',
			pale: '#D6E6FF',
		},
		navigationButtonColor: {
			main: '#FFF',
		},
		regNumberColor: {
			main: '#0D5EE3',
		},
		annualMileageFont: {
			main: '#1F2241',
		},
		contrastThreshold: 3,
		tonalOffset: 0.2,
		background: {
			default: '#FAFBFC',
		},
		footer: {
			main: '#141E7E',
			dark: '#0F175F',
		},
		icon: {
			main: '#0D5EE3',
		},
	},
});

theme = createTheme(theme, {
	components: {
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 0,
				},
			},
		},
		MuiTypography: {
			defaultProps: {
				variantMapping: {
					'dashboard-card-heading': 'h2',
				},
			},
		},
		MuiAppBar: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.secondary.dark,
					color: theme.palette.common.white,
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					borderColor: theme.palette.common.black,
				},
				notchedOutline: {
					borderColor: theme.palette.common.black,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: ({ ownerState }: { ownerState: { color: string; variant?: string } }) => ({
					...(ownerState.variant !== 'text' && {
						...(ownerState.color === 'secondary' && {
							borderColor: theme.palette.common.black,
							':hover': {
								backgroundColor: 'rgba(13, 94, 227, 0.9)',
							},
						}),
						...(ownerState.color === 'primary' && {
							borderColor: theme.palette.common.black,
							':hover': {
								backgroundColor: 'rgba(237, 133, 93, 0.9)',
							},
						}),
					}),
				}),
			},
			variants: [
				{
					props: { variant: 'link' },
					style: {
						...theme.typography.body1,
						color: theme.palette.primary.main,
						textDecoration: 'underline',
						padding: 0,
						background: 'transparent',
						'&:hover': {
							color: theme.palette.primary.light,
							background: 'transparent',
							textDecoration: 'underline',
						},
						'&:visited': {
							background: 'transparent',
							color: theme.palette.primary.main,
							'&:hover': {
								color: theme.palette.primary.light,
							},
						},
					},
				},
			],
		},
		MuiToggleButton: {
			styleOverrides: {
				root: {
					color: theme.palette.common.black,
					borderColor: theme.palette.common.black,
					'&.Mui-selected': {
						backgroundColor: theme.palette.primary.main,
						color: theme.palette.common.white,
						'&:hover': {
							backgroundColor: theme.palette.primary.main,
						},
					},
				},
			},
		},
		MuiCssBaseline: {
			styleOverrides: `
        body, html, #root {
          height: 100%;
        }
        html {
          overflow-y: scroll;
        }
        /* ===== Scrollbar CSS ===== */
        /* Firefox */
        * {
          scrollbar-width: thin;
          scrollbar-color: ${theme.palette.grey[500]} ${theme.palette.background.default};
        }

        /* Chrome, Edge, and Safari */
        *::-webkit-scrollbar {
          width: 12px;
        }

        *::-webkit-scrollbar-track {
          background: ${theme.palette.background.default};
        }

        *::-webkit-scrollbar-thumb {
          background-color: ${theme.palette.grey[500]};
          border-radius: 10px;
          border: 3px solid ${theme.palette.background.default};
        }`,
		},
	},
});

const themeExport = theme;
export default themeExport;
